import type { SwitchTokens } from './types';

export const switchTokens: SwitchTokens = {
  sizes: {
    container: {
      medium: {
        width: '56px',
        height: '2',
      },
    },
    slider: {
      medium: {
        width: 'auto',
        height: 'auto',
        bubbleSize: '1',
      },
    },
  },
  colors: {
    bg: 'neutral.50',
    borderColor: 'neutral.60',
    checkedBg: 'brandPrimary.1',
    checkedBorderColor: 'transparent',
    activeBg: 'neutral.50',
    checkedVersionBBG: 'neutral.50',
    ghost: {
      bg: '',
      checkedVersionBBG: '',
      checkedBorderColor: '',
      borderColor: '',
      offColor: '',
    },
  },
  space: {
    left: '2x_small',
    checkedLeft: '2x_small',
  },
};
